import React  from 'react';
import './Block.css';

const block=(props) => {
    return(
<div className="Block">
    <p hidden>props.blockNumber</p>
    <h3> {props.blockHeader}</h3>
    <p id="p_wrap">{props.blockBody}</p>
</div>
)
};
export default block;



// WEBPACK FOOTER //
// ./src/components/Block/Block.js